export default {
  postingEvent: 'formsTypes/events/postingEvent',
  postEventSuccess: 'formsTypes/events/postEventSuccess',
  postEventFail: 'formsTypes/events/postEventFail',
  addTask: 'formsTypes/events/addTask',
  removeTask: 'formsTypes/events/removeTask',
  clearForm: 'formsTypes/events/clearForm',
  reorderTasks: 'formsTypes/events/reorderTasks',
};
